import styled from 'styled-components';
import userCustomContent from 'styles/userCustomContent';
import Chip from '../../../../Chip';
import HelperText from '../../../../HelperText';

export const RatingFormContainer = styled.div`
  padding-bottom: 10px;
`;

export const CategoryContainer = styled.div`
  margin-top: 30px;
  text-align: center;
  margin-bottom: 18px;
`;

export const Category = styled(Chip)`
  margin-right: 12px;
  margin-bottom: 12px;
  cursor: pointer;
`;

export const FieldLabel = styled.div`
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
  line-height: 1.5;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 700;
  margin-bottom: 12px;
  ${userCustomContent}
`;

export const FieldDescription = styled.span`
  font-weight: 400;
`;

export const SubmitButtonContainer = styled.div`
  margin-top: 30px;
  text-align: center;
`;

export const ErrorMessage = styled(HelperText).attrs({
  isError: true,
})`
  display: block;
  margin-top: 8px;
`;
